import { render } from "./CardTab.vue?vue&type=template&id=ff1dffc0&scoped=true&ts=true"
import script from "./CardTab.vue?vue&type=script&lang=ts"
export * from "./CardTab.vue?vue&type=script&lang=ts"

import "./CardTab.vue?vue&type=style&index=0&id=ff1dffc0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff1dffc0"]])

export default __exports__